import { ContainerModule } from '@evertel/di'
import { AppVersionService } from './AppVersionService'
import { LoginService } from './LoginService'
import { LogoutService } from './LogoutService'
import { SessionService } from './SessionService'
import { DeviceTokenService } from './DeviceTokenService'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(SessionService).toSelf().inSingletonScope()
        m.bind(LoginService).toSelf().inSingletonScope()
        m.bind(LogoutService).toSelf().inSingletonScope()
        m.bind(DeviceTokenService).toSelf().inSingletonScope()
        m.bind(AppVersionService).toSelf().inSingletonScope()
    })
]

export {
    DI_MODULES
}
